import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { ScheduleWorker } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';

export function ViewNotesModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  onClosed?: () => void;
  onConfirm?: () => void;
  scheduledWorker: ScheduleWorker;
}): ReactElement {
  const { isOpen, closeModal, scheduledWorker, onClosed } = props;

  return (
    <Modal
      actionsPanel={null}
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      size="xs"
      title="Scheduled Worker Notes"
    >
      <p>{scheduledWorker?.notes || 'No notes available.'}</p>
    </Modal>
  );
}
